export default "__VITE_ASSET__BUza_M5K__"